// Copyright ©️ 2026 eVolve MEP, LLC

/* oxlint-disable typescript/no-explicit-any */

import React, { Component } from 'react';

import { ErrorPage } from './ErrorPage';

export class ErrorBoundary extends Component<
  any,
  {
    hasError: boolean;
    error?: any;
    errorInfo?: any;
  }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any, errorInfo: any) {
    return { hasError: true, error, errorInfo };
  }

  async componentDidCatch(_error: any) {
    // TODO: Report the error to some central error collector, like AWS RUM
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return <ErrorPage />;
    }
    return children;
  }
}
